import ChangePassword from "../pages/auth/ChangePassword.jsx";
import Forgot from "../pages/auth/Forgot.jsx";
import Login from "../pages/auth/Login.jsx";
import Otp from "../pages/auth/Otp.jsx";
import Dashboard from "../pages/dashboard/Dashboard.jsx";
import Account from "../pages/account/Account.jsx";
import Organizer from "../pages/templates/organizer/Organizer.jsx";
import OrganizerInit from "../pages/templates/organizer/OrganizerInit.jsx";
import CellsAndForms from "../pages/settings/cellsAndForm/CellsAndForms.jsx";
import ReviewDoc from "../pages/reviewDoc/ReviewDoc.jsx";
import ViewReviewDoc from "../pages/reviewDoc/components/ViewReviewDoc.jsx";
import PrepareTax from "../pages/prepareTax/PrepareTax.jsx";
import ViewPrepareTax from "../pages/prepareTax/components/ViewPrepareTax.jsx";
import ReviewTax from "../pages/reviewTax/ReviewTax.jsx";
import ViewReviewTax from "../pages/reviewTax/components/ViewReviewTax.jsx";
import FollowUp from "../pages/followUp/FollowUp.jsx";
import ReturnToGov from "../pages/returnToGov/ReturnToGov.jsx";
import ViewReturnToGov from "../pages/returnToGov/components/ViewReturnToGov.jsx";
import Team from "../pages/team/Team.jsx";
import Clients from "../pages/clients/Clients.jsx";
import Client from "../pages/clients/components/Client.jsx";
import InvoiceTemplate from "../pages/templates/Invoice/InvoiceTemplate.jsx";
import Communication from "../pages/communication/Communication.jsx";
import BusinessTask from "../pages/businessTask/BusinessTask.jsx";
import Tags from "../pages/settings/tags/Tags.jsx";
import Provinces from "../pages/settings/provinces/Provinces.jsx";
import Organizers from "../pages/organizers/Organizers.jsx";
import EmployeeDashboard from "../pages/employeeDashboard/EmployeeDashboard.jsx";
import TeamConnect from "../pages/teamConnect/TeamConnect.jsx";
import Faq from "../pages/settings/faq/Faq.jsx";
import OrganizerReport from "../pages/reports/organizer/OrganizerReport.jsx";
import OrganizerReportReview from "../pages/reports/organizer/OrganizerReportReview.jsx";
import AuditReport from "../pages/reports/auditReport/AuditReport.jsx";
import ViewTeam from "../pages/team/components/ViewTeam.jsx";
import ViewBusinessTask from "../pages/businessTask/components/ViewBusinessTask.jsx";
import Settings from "../components/settings/Settings.jsx";
import TFAuthenticator from "../pages/auth/TFAuthenticator.jsx";
import EmailTemplate from "../pages/templates/email/EmailTemplate.jsx";
import ActiveJobReport from "../pages/reports/activeJob/ActiveJobReport.jsx";
import CompleteJobReport from "../pages/reports/completeJob/CompleteJobReport.jsx";
import OverdueJobTask from "../pages/reports/overdueTask/OverdueJobTask.jsx";
import ViewFollowUp from "../pages/followUp/components/ViewFollowUp.jsx";
import OrganizerDoc from "../pages/clients/components/ClientOrganizerDoc.jsx";
import ReferralReport from "../pages/reports/referralReport/ReferralReport.jsx";
import Payment from "../pages/reports/payment/Payment.jsx";
import RestoreUser from "../pages/settings/restoreUser/RestoreUser.jsx";
import Activity from "../pages/activity/Activity.jsx";

export const initialRoutes = () => {
  const routes = [
    // ============ Auth ===============
    { path: "/login", type: "auth", component: Login, title: "Login" },
    { path: "/otp", type: "auth", component: Otp, title: "Otp" },
    {
      path: "/forgot_password",
      type: "auth",
      component: Forgot,
      title: "ForgotPassword",
    },
    {
      path: "/change_password/:token",
      type: "auth",
      component: ChangePassword,
      title: "ChangePassword",
    },
    {
      path: "/authentication",
      type: "auth",
      component: TFAuthenticator,
      title: "Authentication",
    },

    // ============ Privet ==============
    { path: "/", type: "private", component: Dashboard, title: "Dashboard" },
    {
      path: "/dashboard",
      type: "private",
      component: Dashboard,
      title: "Dashboard",
    },
    {
      path: "/employee_dashboard",
      type: "private",
      component: EmployeeDashboard,
      title: "Employee Dashboard",
    },

    {
      path: "/organizer_template/:organizerTypeId",
      type: "private",
      component: Organizer,
      title: "Organizer Template",
    },
    {
      path: "/organizer_template",
      type: "private",
      component: OrganizerInit,
      title: "Organizer Template",
    },

    { path: "/account", type: "private", component: Account, title: "Account" },

    {
      path: "/verify_doc",
      type: "private",
      component: ReviewDoc,
      title: "Organizers",
    },
    {
      path: "/verify_doc/:id",
      type: "private",
      component: ViewReviewDoc,
      title: "Organizers",
    },

    {
      path: "/prepare_tax",
      type: "private",
      component: PrepareTax,
      title: "Organizers",
    },
    {
      path: "/prepare_tax/:id",
      type: "private",
      component: ViewPrepareTax,
      title: "Organizers",
    },

    {
      path: "/review_tax",
      type: "private",
      component: ReviewTax,
      title: "Organizers",
    },
    {
      path: "/review_tax/:id",
      type: "private",
      component: ViewReviewTax,
      title: "Organizers",
    },

    {
      path: "/follow_up",
      type: "private",
      component: FollowUp,
      title: "Organizers",
    },
    {
      path: "/follow_up/:id",
      type: "private",
      component: ViewFollowUp,
      title: "Organizers",
    },
    {
      path: "/e_file",
      type: "private",
      component: ReturnToGov,
      title: "Organizers",
    },
    {
      path: "/e_file/:id",
      type: "private",
      component: ViewReturnToGov,
      title: "Organizers",
    },

    { path: "/team", type: "private", component: Team, title: "Team" },
    { path: "/team/:id", type: "private", component: ViewTeam, title: "Team" },

    // {
    //   path: "/communication",
    //   type: "private",
    //   component: Communication,
    //   title: "Communication",
    // },

    // {
    //   path: "/team_connect",
    //   type: "private",
    //   component: TeamConnect,
    //   title: "Team Connect",
    // },

    { path: "/clients", type: "private", component: Clients, title: "Clients" },
    {
      path: "/client/organizer/:id",
      type: "private",
      component: OrganizerDoc,
      title: "Clients",
    },
    {
      path: "/client/:id",
      type: "private",
      component: Client,
      title: "Client",
    },

    {
      path: "/task",
      type: "private",
      component: BusinessTask,
      title: "Business Task",
    },
    {
      path: "/task/:id",
      type: "private",
      component: ViewBusinessTask,
      title: "Business Task",
    },

    {
      path: "/email_template",
      type: "private",
      component: EmailTemplate,
      title: "Email Templates",
    },

    {
      path: "/organizers",
      type: "private",
      component: Organizers,
      title: "Organizers",
    },

    {
      path: "/activity",
      type: "private",
      component: Activity,
      title: "Activity Tracker",
    },
    {
      path: "/report/referral",
      type: "private",
      component: ReferralReport,
      title: "Referral Reports",
    },
    {
      path: "/report/organizer",
      type: "private",
      component: OrganizerReport,
      title: "Organizer Reports",
    },
    {
      path: "/report/organizer/review/:id",
      type: "private",
      component: OrganizerReportReview,
      title: "Organizer Review",
    },
    {
      path: "/report/audit_report",
      type: "private",
      component: AuditReport,
      title: "Audit Report",
    },
    {
      path: "/report/active_job",
      type: "private",
      component: ActiveJobReport,
      title: "Active Job Reports",
    },
    {
      path: "/report/complete_job",
      type: "private",
      component: CompleteJobReport,
      title: "Complete Job Reports",
    },
    {
      path: "/report/overdue_task",
      type: "private",
      component: OverdueJobTask,
      title: "Overdue Task Reports",
    },
    {
      path: "/report/payment",
      type: "private",
      component: Payment,
      title: "Payment Reports",
    },
    {
      path: "/cells_and_forms",
      type: "private",
      component: CellsAndForms,
      title: "Cells & Forms",
    },
    {
      path: "/invoice_template",
      type: "private",
      component: InvoiceTemplate,
      title: "Invoice Templates",
    },
    { path: "/tags", type: "private", component: Tags, title: "Tags" },
    {
      path: "/provinces",
      type: "private",
      component: Provinces,
      title: "Provinces",
    },
    { path: "/faq", type: "private", component: Faq, title: "FAQ" },
    {
      path: "/restore_user",
      type: "private",
      component: RestoreUser,
      title: "Restore User",
    },
    {
      path: "/settings",
      type: "private",
      component: Settings,
      title: "Settings",
    },
  ];
  return routes;
};
